// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import MarketplacePhotosController from "./marketplace_photos_controller"
import MarketplaceGalleryController from "./marketplace_gallery_controller"
import MarketplaceStateController from "./marketplace_state_controller"
import PostUploadsController from "./post_uploads_controller"

application.register("marketplace-photos", MarketplacePhotosController)
application.register("marketplace-gallery", MarketplaceGalleryController)
application.register("marketplace-state", MarketplaceStateController)
application.register("post-uploads", PostUploadsController)

import HelloController from "./hello_controller"
import TabsController from "./tabs_controller"
import ChatRoomController from "./chat_room_controller"
import MentionAutocompleteController from "./mention_autocomplete_controller"
import PostReferenceController from "./post_reference_controller"
import CommentReplyController from "./comment_reply_controller"
import MarkdownEditorController from "./markdown_editor_controller"
import DarkModeController from "./dark_mode_controller"
import SidebarController from "./sidebar_controller"
import SearchOverlayController from "./search_overlay_controller"
import CategoryToggleController from "./category_toggle_controller"
import BoardMentionController from "./board_mention_controller"
import ClipboardController from "./clipboard_controller"
import ImageUploadController from "./image_upload_controller"
import FileAttachmentController from "./file_attachment_controller"
import BoardTabsController from "./board_tabs_controller"
import BottomNavController from "./bottom_nav_controller"
import PasswordMatchController from "./password_match_controller"
import DocSearchController from "./doc_search_controller"
import FileDropController from "./file_drop_controller"
import NotificationController from "./notification_controller"
import ChatUploadController from "./chat_upload_controller"
import LinkPreviewController from "./link_preview_controller"

application.register("hello", HelloController)
application.register("tabs", TabsController)
application.register("chat-room", ChatRoomController)
application.register("mention-autocomplete", MentionAutocompleteController)
application.register("post-reference", PostReferenceController)
application.register("comment-reply", CommentReplyController)
application.register("markdown-editor", MarkdownEditorController)
application.register("dark-mode", DarkModeController)
application.register("sidebar", SidebarController)
application.register("search-overlay", SearchOverlayController)
application.register("category-toggle", CategoryToggleController)
application.register("board-mention", BoardMentionController)
application.register("clipboard", ClipboardController)
application.register("image-upload", ImageUploadController)
application.register("file-attachment", FileAttachmentController)
application.register("board-tabs", BoardTabsController)
application.register("bottom-nav", BottomNavController)
application.register("password-match", PasswordMatchController)
application.register("doc-search", DocSearchController)
application.register("file-drop", FileDropController)
application.register("notification", NotificationController)
application.register("chat-upload", ChatUploadController)
application.register("link-preview", LinkPreviewController)
